// Policy.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const TermsModal = ({ show, handleClose, handleAgree }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
    
      <Modal.Title >Terms and Conditions</Modal.Title>

      </Modal.Header>
      <Modal.Body>
      <div align="left">
            <h6>Introduction</h6>
      <p>
        Welcome to SharedVision Partners. By accessing and using our platform, you agree to comply with these Terms and Conditions. If you do not agree, please refrain from using our services.
      </p>

      <h6>Eligibility</h6>
      <p>
        You must be at least 18 years old and legally capable of entering into contracts to use our services. By registering, you confirm that you meet these requirements.
      </p>

      <h6>Account Registration</h6>
      <p>
        To access certain features, users must create an account by providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.
      </p>

      <h6>Investment Terms</h6>
      <p>
        Investments are subject to the terms specified in individual project listings.
        <br />
        Returns may vary based on market conditions.
   
      </p>

      <h6>Fees and Charges</h6>
      <p>
        SharedVision Partners charge fees for certain transactions or services. These fees will be clearly outlined before any charges are applied.
      </p>

      <h6>Withdrawal Policy</h6>
      <p>
        Withdrawals are processed within 48 hours to 3 days.
        <br />
        Additional verification may be required for large withdrawals.
        <br />
        SharedVision Partners is not liable for delays caused by third-party payment processors.
      </p>

      <h6>Risk Disclaimer</h6>
      <p>
        Investing involves financial risks. Past performance does not guarantee future results. Users should only invest funds they can afford to lose.
      </p>

      <h6>Prohibited Activities</h6>
      <p>
        Users must not engage in fraudulent, unlawful, or abusive activities, including but not limited to:
        </p>
        <ul>
          <li>Money laundering</li>
          <li>Hacking or unauthorized access</li>
          <li>Spamming or misrepresentation</li>
        </ul>
      
      <h6>Privacy Policy</h6>
      <p>
        We collect and store user data as outlined in our Privacy Policy. We do not sell or share personal information with third parties without user consent, except as required by law.
      </p>

      <h6>Intellectual Property</h6>
      <p>
        All content, trademarks, and logos on the platform are the property of SharedVision Partners. Unauthorized use or reproduction is strictly prohibited.
      </p>

      <h6>Termination of Services</h6>
      <p>
        We reserve the right to suspend or terminate accounts that violate our terms, engage in fraudulent activity, or pose a security risk.
      </p>

      <h6>Dispute Resolution</h6>
      <p>
      Any disputes will be addressed and resolved by our Support Team's Resolution Panel. Users agree to engage with this panel for resolution, rather than pursuing legal action or class-action lawsuits. </p>

      <h6>Amendments to Terms</h6>
      <p>
        SharedVision Partners may update these Terms and Conditions at any time. Users will be notified of significant changes here, and continued use of the platform constitutes acceptance of revised terms.
      </p>

      <h6>Contact Information</h6>
      <p>
        For inquiries or support, please contact us at: [admin@sharedvision-partners.online] or visit our customer support page.
      </p>

      <p>
        By using SharedVision Partners, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
      </p>
    </div>
        {/* You can add more detailed terms here */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={() => { handleAgree(); handleClose(); }}>
          Agree
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
